
export default {
  name: "Select",

  data: function () {
    return {
      isOpen: false
    }
  },

  props: {
    value: {
      type: [String, Object],
      default: null
    },
    options: {
      type: Array,
      default: () => {
        return []
      }
    },
    placeholder: {
      type: String,
      default: "Выберите"
    }
  },

  computed: {
    selectValue: function () {
      return this.value?.label || this.value || this.placeholder || ""
    }
  },

  methods: {
    onOpen: function () {
      this.isOpen = true;
    },
    onClose: function () {
      this.isOpen = false;
    },

    onSelect: function (item) {
      this.$emit("change", item);
      this.onClose();
    }
  }
}
